import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { Observable } from 'rxjs/Observable';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';

@Injectable()
export class VacunasService extends RESTService<any> {

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/obtenerVacunasPaciente',
    });
  }

  obtenerVacunasPaciente(idPaciente: string): any {
    return this._http.post(environment.api_host + 'vacunas/obtenerVacunasPaciente', {idPaciente: idPaciente}).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }
}



// WEBPACK FOOTER //
// ./src/services/vacunas.service.ts